import _pt from '../../../node_modules/prop-types/index.js';

var minValue = function minValue() {
  return {
    propTypes: {
      minValue: _pt.number,
      minValueError: _pt.string
    },
    shouldValidate: function shouldValidate(props) {
      return typeof props.minValue === "number";
    },
    getErrors: function getErrors(field, value, props) {
      if (typeof value === "number" || typeof value === "string") {
        if (props.minValue !== undefined && parseFloat(value.toString()) < props.minValue) {
          return [props.minValueError || "".concat(field, " must be at least ").concat(props.minValue)];
        }
      }

      return [];
    }
  };
};

export { minValue };
